
<kendo-floatinglabel text="{{label}}">
  <input kendoTextBox name="{{label}}"
         class="form-control" type="text"
         placeholder="{{ label }}"
         readonly="true" [(ngModel)]="value" />
</kendo-floatinglabel>
